import { useLocation } from "react-router-dom";
import {
  Header,
  Image
} from "./styles";

//components

import Buttons from 'components/Buttons'

//images

import SignIn from '../assets/sign-in.webp'
import SignUp from '../assets/sign-up.webp'
import RecoveryImageOne from '../assets/recovery-one.webp'

//icons

import ArrowLeftIcon from "components/StaticIcons/Arrows/ArrowLeft";

export default function AuthHeader() {

  const location = useLocation()

  function getImage() {

    switch (location.pathname) {
      case "sign-in":
        return SignIn
      case "sign-up":
        return SignUp
      case "restore-password":
        return SignUp
      case "recovery":
        return RecoveryImageOne
      default:
        return SignIn
    }

  }

  return (
    <Header>
      <Buttons leftIcon={<ArrowLeftIcon />} variable="outline" height="big">
        Back
      </Buttons>
      <Image path={getImage()} />
    </Header>
  )
}
